import { Stack, Typography } from '@mui/material';

import WebIcon from '../../../icons/WebIcon';

export interface NoPollsProps {
  message: string;
  className?: string;
}

const NoPolls = ({ message, className }: NoPollsProps) => {
  return (
    <Stack justifyContent="center" alignItems="center" overflow="hidden" className={className}>
      <Stack alignItems="center" gap={2} overflow="hidden">
        <WebIcon size={48} color="grey.300" />
        <Typography variant="h6Medium" component="p" textAlign="center" width={270}>
          {message}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NoPolls;
